class Drawer extends HTMLElement {
    constructor() {
        super();
        this.setListeners()
        this.isDesktop = window.innerWidth > 1024;
    }

    setListeners() {

        this.details = this.querySelector('[data-details]')
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('[data-overlay]')?.addEventListener('click', () => {
            this.close.bind(this)()
        });
        const closeBtns = this.querySelectorAll('[data-drawer-close]');
        closeBtns?.forEach(btn => btn.addEventListener('click', this.close.bind(this)));

        subscribe(PUB_SUB_EVENTS.onCloseDrawerEvent, (event) => {
            this.handleExternalClose(event.target);
        });
    }

    setIconAccessibility(detailsLink) {
        this.details.classList.add(this.isDesktop ? 'desktop-drawer' : 'mobile-drawer');

        detailsLink.setAttribute('role', 'button');
        detailsLink.setAttribute('aria-haspopup', 'dialog');
        detailsLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(detailsLink);
        });
        this.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                this.open(this);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate');
            this.setAttribute('open', '');
        });

        this.addEventListener(
            'transitionend',
            () => {
                trapFocus(this, this.details);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');
    }

    handleExternalClose(source) {
        const type = this.dataset.type;
        if (!type || type !== source) return;
        this.close();
    }

    close() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}


class DrawerCloser extends HTMLElement {
    constructor() { super() }

    connectedCallback() {
        this.onClose = this.addEventListener('click', () => {
            publish(PUB_SUB_EVENTS.onCloseDrawerEvent, {
                target: this.dataset.type
            });
        });
    }

    disconnectedCallback() {
        this.onClose && this.onClose();
    }
}

customElements.define('drawer-closer', DrawerCloser);